import { ReactElement } from 'react';
import { Link } from '@framework/router/Next/Link';
import Flex from '@creditflowresearch/uilib/Flex';

import styles from './links.module.scss';

export interface ILinkConfig {
  url: string,
  dataTest: string,
  label: string,
  target?: string,
  rel?: string,
}

interface ILinksProps {
  config: ILinkConfig[],
  dataTest?: string,
}

const Links = ({ config, dataTest = 'headerLinks' }: ILinksProps): ReactElement => {
  return (
    <Flex
      dataTest={ dataTest }
      gap={ 16 }
      justify="flex-end"
      align="center"
    >
      { config.map(({ url, dataTest: linkDataTest, label, target }) => (
        <Link
          className={ styles.link }
          key={ url }
          to={ url }
          dataTest={ linkDataTest }
          target={ target }
          rel={ target === '_blank' ? 'noopener noreferrer' : undefined }
        >
          { label }
        </Link>
      )) }
    </Flex>
  );
};

export default Links;
